// extracted by mini-css-extract-plugin
export var card = "_mw-1";
export var summary = "_mw-0";